import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

function AllContestants() {
  const [contestants, setContestants] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const category = searchParams.get('category') || 'flower';

  useEffect(() => {
    fetchContestants();
  }, [category]);

  const fetchContestants = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/rankings?category=${category}`);
      setContestants(response.data);
    } catch (error) {
      console.error('Error fetching contestants:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleCategory = () => {
    const newCategory = category === 'flower' ? 'grass' : 'flower';
    navigate(`/all-contestants?category=${newCategory}`);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-96">
        <span className="loading loading-spinner loading-lg text-pink-500"></span>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-pink-500 mb-4">
            {category === 'flower' ? '校花' : '校草'}參賽者名單
          </h1>
          <button
            onClick={toggleCategory}
            className="btn bg-pink-500 hover:bg-pink-600 text-white mb-4"
          >
            切換到{category === 'flower' ? '校草' : '校花'}
          </button>
          <a
            href="/"
            className="btn btn-ghost text-pink-500 ml-2"
          >
            返回主頁
          </a>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {contestants.map((contestant, index) => (
            <div key={contestant.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="aspect-square">
                <img
                  src={`${API_URL}${contestant.photo_url}`}
                  alt={contestant.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-4">
                <h3 className="text-xl font-semibold text-gray-800">{contestant.name}</h3>
                <p className="text-gray-600">
                  排名: {index + 1}
                </p>
                <p className="text-gray-600">
                  分數: {contestant.score.toFixed(2)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AllContestants;
